import Constant from '@/common/constant/Constant';
import { MenuItem, TextField, ListSubheader, Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';

export default function Filters(props) {
    const handleOnchangeFilterCreator = (event) => {
        props.setFilterCreator(event.target.value);
    };

    const handleOnchangeFilterHelpDesk = (event) => {
        props.setFilterHelpDesk(event.target.value);
    };

    const handleOnChangeFilterNotice = (event) => {
        let value = event.target.value === 'all' ? '' : event.target.value;
        props.setFilterHelpDeskNotice(value);
    };

    let internalHelpDeskList = props.helpDeskList.filter(
        (item) => item.helpDeskType === Constant.HELPDESK_LIST_TYPE.INTERNAL
    );
    let externalHelpDeskList = props.helpDeskList.filter(
        (item) => item.helpDeskType === Constant.HELPDESK_LIST_TYPE.EXTERNAL
    );

    if (props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.NOTICE_VIEW) {
        const helpDeskIdList = props.helpDeskListInNotice
        const internalHelpDeskNoticeList = helpDeskIdList && helpDeskIdList.length ? internalHelpDeskList.filter((helpDesk) => helpDeskIdList.includes(helpDesk.id)) : [];
        const externalHelpDeskNoticeList = helpDeskIdList && helpDeskIdList.length ? externalHelpDeskList.filter((helpDesk) => helpDeskIdList.includes(helpDesk.id)) : [];
        return (
            <div className="qa-filter-wrap" data-cy="ticket-list-filter">
                <div className="qa-filter-group" data-cy="filter-field-frame">
                    <label className="filter-label" data-cy="filter-status-title">発行プロジェクト</label>
                    <div className="filter-input" data-cy="filter-status-selectbox">
                        <TextField
                            className="form-control form-control--wrap form-control--hg32"
                            select
                            variant="outlined"
                            value={props.filterHelpDeskNotice ? props.filterHelpDeskNotice : 'all'}
                            onChange={(e) => handleOnChangeFilterNotice(e)}
                            SelectProps={{
                                MenuProps: {
                                    anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left"
                                    },
                                    getContentAnchorEl: null,
                                    className: "selectDrop"
                                }
                            }}
                        >
                            <MenuItem value="all">全て</MenuItem>
                            {!Utils.isEmptyArray(internalHelpDeskNoticeList) && (
                                <ListSubheader
                                    className="list-sub-header"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={(e) => e.stopPropagation()}
                                >
                                    組織内プロジェクト
                                </ListSubheader>
                            )}
                            {internalHelpDeskNoticeList?.map((helpDesk) => helpDeskIdList.includes(helpDesk.id) && (
                                <Tooltip key={helpDesk.id} value={helpDesk.id} title={helpDesk.shortName} placement="top" arrow interactive>
                                    <MenuItem className="filter-menu-item">
                                        <div className="filter-helpDesk-item">{helpDesk.shortName}</div>
                                    </MenuItem>
                                </Tooltip>
                            ))}
                            {!Utils.isEmptyArray(externalHelpDeskNoticeList) && (
                                <ListSubheader
                                    className="list-sub-header"
                                    color="inherit"
                                    disableSticky
                                    onClickCapture={(e) => e.stopPropagation()}
                                >
                                    組織外プロジェクト
                                </ListSubheader>
                            )}
                            {externalHelpDeskNoticeList?.map((helpDesk) => helpDeskIdList.includes(helpDesk.id) && (
                                <Tooltip key={helpDesk.id} value={helpDesk.id} title={helpDesk.displayName} placement="top" arrow interactive>
                                    <MenuItem className="filter-menu-item">
                                        <div className="filter-helpDesk-item">{helpDesk.displayName}</div>
                                    </MenuItem>
                                </Tooltip>
                            ))}
                            
                            {/* {props.helpDeskList?.map((helpDesk) => helpDeskIdList && helpDeskIdList.includes(helpDesk.id) && (
                                <MenuItem value={helpDesk.id}>{helpDesk.shortName }</MenuItem>
                            ))} */}
                        </TextField>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="qa-filter-wrap qa-filter-container" data-cy="ticket-list-filter">
            {props.projectInuseDetail.type !== Constant.PROJECT_TYPE.BASE &&
                props.projectInuseDetail.type !== Constant.PROJECT_TYPE.CUSTOMER && (
                    <div className="qa-filter-group" data-cy="filter-field-frame">
                        <label className="filter-label" data-cy="filter-status-title">チケット発行者</label>
                        <div className="filter-input" data-cy="filter-status-selectbox">
                            <TextField
                                className="form-control form-control--wrap form-control--hg32"
                                select
                                variant="outlined"
                                value={props.filterCreator}
                                onChange={(e) => handleOnchangeFilterCreator(e)}
                                disabled={props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.DRAFT_QA_VIEW}
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null,
                                        className: "selectDrop"
                                    }
                                }}
                            >
                                {props.viewSelected === Constant.CUSTOMER_SIDE_VIEW.ARCHIVE_QA_VIEW && <MenuItem value={Constant.QA_FILTER_CREATOR.ALL}>全て</MenuItem>}
                                <MenuItem value={Constant.QA_FILTER_CREATOR.ME}>自分</MenuItem>
                                <MenuItem value={Constant.QA_FILTER_CREATOR.PROJECT_MEMBER}>
                                    プロジェクトメンバー{' '}
                                </MenuItem>
                            </TextField>
                        </div>
                    </div>
                )}
            <div className="qa-filter-group" data-cy="filter-field-frame">
                <label className="filter-label" data-cy="filter-status-title">問い合わせ先</label>
                <div className="filter-input" data-cy="filter-status-selectbox">
                    <TextField
                        className="form-control form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        value={props.filterHelpDesk}
                        onChange={(e) => handleOnchangeFilterHelpDesk(e)}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null,
                                className: "selectDrop"
                            }
                        }}
                    >
                        <MenuItem value="">&#8203;</MenuItem>
                        {!Utils.isEmptyArray(internalHelpDeskList) && (
                            <ListSubheader
                                className="list-sub-header"
                                color="inherit"
                                disableSticky
                                onClickCapture={(e) => e.stopPropagation()}
                            >
                                組織内プロジェクト
                            </ListSubheader>
                        )}
                        {internalHelpDeskList?.map((helpDesk) => (
                            <Tooltip key={helpDesk.id} value={helpDesk.id} title={helpDesk.displayName} placement="top" arrow interactive>
                                <MenuItem className="filter-menu-item">
                                    <div className="filter-helpDesk-item">{helpDesk.displayName}</div>
                                </MenuItem>
                            </Tooltip>
                        ))}
                        {!Utils.isEmptyArray(externalHelpDeskList) && (
                            <ListSubheader
                                className="list-sub-header"
                                color="inherit"
                                disableSticky
                                onClickCapture={(e) => e.stopPropagation()}
                            >
                                組織外プロジェクト
                            </ListSubheader>
                        )}
                        {externalHelpDeskList?.map((helpDesk) => (
                            <Tooltip key={helpDesk.id} value={helpDesk.id} title={helpDesk.displayName} placement="top" arrow interactive>
                                <MenuItem className="filter-menu-item">
                                    <div className="filter-helpDesk-item">{helpDesk.displayName}</div>
                                </MenuItem>
                            </Tooltip>
                        ))}
                    </TextField>
                </div>
            </div>
        </div>
    );
}
